import { GOOGLE_MAPS_API_KEY } from 'env';
import { useEffect, useState } from 'react';

/**
 * Manage the concurrent loading of Google Map script tag to the HTML.
 */
const googleMapsScriptLoader = {
    isLoaded: false,
    isLoading: false,
    callbacks: [],
    loadScript: function (callback: () => void) {
        if (this.isLoaded) {
            callback();
            return;
        }
        this.callbacks.push(callback);
        // otherwise several components would load the script simultaneously
        if (this.isLoading) return;
        this.isLoading = true;
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`;
        script.async = true;
        script.onload = () => {
            this.isLoaded = true;
            this.isLoading = false;
            // if multiple components are loading the script at the same time, they will have
            // queued their callbacks in this.callbacks, so we execute them all now.
            this.callbacks.forEach((cb: () => void) => cb());
        };
        document.body.appendChild(script);
    },
};

/**
 * Add the Google Maps script to the HTML and return a boolean indicating
 * when the script has been loaded.
 */
export const useLoadGoogleMaps = (): boolean => {
    const [isGMapsAPILoaded, setIsGMapsAPILoaded] = useState(false);
    useEffect(() => {
        googleMapsScriptLoader.loadScript(() => setIsGMapsAPILoaded(true));
    }, []);

    return isGMapsAPILoaded;
};
